export const parseSeconds = (seconds) => {
  const days = seconds / (24 * 60 * 60);
  const hours = (seconds % (24 * 60 * 60)) / (60 * 60);
  const minutes = (seconds % (60 * 60)) / 60;

  return [days, hours, minutes, seconds % 60].map(Math.floor);
}
